import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { useAppContext } from '../../contexts/MarketPerformanceContext';
import { VoidState } from '../../utilities/VoidState';

const LastUpdatedIndicator = ({ showMarketOpenTime }) => {
    const { state: { marketIndex } } = useAppContext();

    if (!marketIndex.asAt || !marketIndex.asAt.length) {
        return (
            <VoidState message='Last updated date not available' classes='last-updated-indicator d-flex justify-content-end' />
        );
    }

    const lastUpdated = moment(marketIndex.asAt).format('DD MMM YYYY, hh:mm A');

    return (
        <div className="last-updated-indicator">
            <div className="d-none d-sm-inline-flex text-right float-sm-right">
                <LastUpdated updatedDate={lastUpdated} showMarketOpenTime={showMarketOpenTime} />
                <div className="indicator-image pt-1 pl-2 pr-0">
                    <img src="/resources/themes/forsythbarr/dist/media/last-update-indicator.svg" width="35" height="33px" alt="last update indicator" />
                </div>
            </div>
            <div className="d-inline-flex d-sm-none">
                <div className="indicator-image pt-1 pr-2 pl-2">
                    <img src="/resources/themes/forsythbarr/dist/media/last-update-indicator.svg" width="35" height="33px" alt="last update indicator" />
                </div>
                <LastUpdated updatedDate={lastUpdated} showMarketOpenTime={showMarketOpenTime} />
            </div>
        </div>
    );
};

LastUpdatedIndicator.propTypes = {
    showMarketOpenTime: PropTypes.bool,
};

LastUpdatedIndicator.defaultProps = {
    showMarketOpenTime: false,
};

const LastUpdated = ({ updatedDate, showMarketOpenTime }) => {
    const { state: { marketIndex } } = useAppContext();

    const NZ_TIME_ZONE = 'Pacific/Auckland';
    const day = moment().tz(NZ_TIME_ZONE)?.format('dddd')?.toLowerCase();
    const hours = marketIndex?.openingHours;
    const today = hours?.openingHours?.find((item) => item?.day === day);

    const from = moment(today?.from).tz(NZ_TIME_ZONE).format('h:mma');
    const to = moment(today?.to).tz(NZ_TIME_ZONE).format('h:mma');

    return (
        <div className="last-updated">
            <p className="last-updated-date">{updatedDate} NZST</p>
            <p className="message">All stock prices and news delayed 20 minutes</p>
            {showMarketOpenTime && today?.from && today?.to && <p className="message"><strong>Market hours:</strong> Mon-Fri, {from} - {to} NZST</p>}
        </div>
    );
};

LastUpdated.propTypes = {
    updatedDate: PropTypes.string,
    showMarketOpenTime: PropTypes.bool,
};

export default LastUpdatedIndicator;
